export default __webpack_public_path__ + "static/media/light-graph-icon.84674db6.svg";